export default __webpack_public_path__ + "static/logo_ar-7d705e521c7ad0f21322bb1e32837ec9.png";